import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AudiencePreviewDto } from "../../../models/campaign/dto/campaign.dto";

export const usePreviewAudience = (campaignId: string, enabled = false) => {
    const client = useApiClient();

    return useQuery({
        queryKey: ['campaigns', campaignId, 'audience-preview'],
        queryFn: () => client.fetchApi<AudiencePreviewDto, {}>({
            endpoint: `campaigns/admin/${campaignId}/audience-preview`,
            method: 'GET'
        }),
        enabled: !!campaignId && enabled,
    });
};
